import axios from '@axios'

const PREFIX = '/parametrizacao'

export default {

  salvarParametrizacaoGeral(config) {
    return axios.post(`${PREFIX}/geral`, config)
  },

  getParemtrizacaoGeral() {
    return axios.get(`${PREFIX}/geral`)
  },

  getUrlArquivo() {
    return axios.get(`${PREFIX}/url-arquivo`)
  },

  getUrlVideo() {
    return axios.get(`${PREFIX}/url-video`)
  },

  getParametrizacaoResumida() {
    return axios.get(`${PREFIX}/parametrizacao-resumida`)
  },

  getUrlArquivoPortal() {
    return axios.get(`${PREFIX}/portal-proposta/url-arquivo`)
  },

  getUrlVideoPortal() {
    return axios.get(`${PREFIX}/portal-proposta/url-video`)
  },

  getParametrizacaoResumidaPortal() {
    return axios.get(`${PREFIX}/portal-proposta/parametrizacao-resumida`)
  },
}
